import _Accordion from "@material-ui/core/esm/Accordion";
import _AccordionDetails from "@material-ui/core/esm/AccordionDetails";
import _AccordionSummary from "@material-ui/core/esm/AccordionSummary";
import React, { useState } from 'react';
import cn from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import AddIcon from '@material-ui/icons/Add';
import MinimizeIcon from '@material-ui/icons/Minimize';
import fastAppearAnimationClasses from '../../../../../animations/fast-appear.anim.scss';
import { CheckboxSection } from './components/checkbox-section';
import ColorSection from './components/color-section';
import PriceRange from './components/price-range';
import { BoxAndInventory } from './components/box-and-inventory';
import { isShowSelectAll, lowercaseConjunction } from './filter-item.util';
import appearAnimationClasses from './appear.anim.scss';
import classes from './filter-item.scss';
export let Type = /*#__PURE__*/function (Type) {
  Type[Type["CHECKBOX"] = 0] = "CHECKBOX";
  Type[Type["COLOR_CIRCLES"] = 1] = "COLOR_CIRCLES";
  Type[Type["PRICE_RANGE"] = 2] = "PRICE_RANGE";
  Type[Type["RADIOBUTTON"] = 3] = "RADIOBUTTON";
  Type[Type["BOX_AND_INVENTORY"] = 4] = "BOX_AND_INVENTORY";
  return Type;
}({});
export const FilterItem = ({
  type,
  data,
  selectedFilter,
  disabledFilter = {},
  filterItem: {
    filterId,
    filterName,
    filterData
  },
  isAttributes = false,
  isAllFilterItemsSelected,
  className,
  color = '',
  onChangeCheckboxFilter,
  onChangeRadioFilter,
  onChangePriceRange,
  onChangeBox,
  onInventoryChange,
  onSuperSpeedChange,
  onSelectAll
}) => {
  const [isItemOpened, setIsItemOpened] = useState(true);
  const handlePanelClick = () => {
    !isItemOpened && setIsItemOpened(true);
  };
  const handleMinimizeIconClick = () => {
    setIsItemOpened(false);
  };
  const selectTypeOfFilterItem = () => {
    switch (type) {
      case Type.CHECKBOX:
        return /*#__PURE__*/React.createElement(CheckboxSection, {
          filterData: data,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          dataInput: filterName,
          color: color,
          onClickCheckbox: (filterPropertyValue, categoriesIdToRemove) => onChangeCheckboxFilter(filterId, filterPropertyValue, isAttributes, categoriesIdToRemove)
        });
      case Type.RADIOBUTTON:
        return /*#__PURE__*/React.createElement(CheckboxSection, {
          filterData: data,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          dataInput: filterName,
          onClickCheckbox: filterPropertyValue => onChangeRadioFilter(filterId, filterPropertyValue)
        });
      case Type.COLOR_CIRCLES:
        return /*#__PURE__*/React.createElement(ColorSection, {
          filterData: data,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          onClickCheckbox: filterPropertyValue => onChangeCheckboxFilter(filterId, filterPropertyValue, false)
        });
      case Type.PRICE_RANGE:
        return /*#__PURE__*/React.createElement(PriceRange, {
          filterData: data,
          isDisabled: disabledFilter[filterId],
          selectedFilter: selectedFilter[filterId],
          color: color,
          onChange: filterPropertyValue => onChangePriceRange(filterId, filterPropertyValue)
        });
      case Type.BOX_AND_INVENTORY:
        return /*#__PURE__*/React.createElement(BoxAndInventory, {
          filterData: data,
          isDisabled: disabledFilter[filterId],
          isBoxSelected: selectedFilter.isBox,
          isInventorySelected: selectedFilter.isInventory,
          isSuperSpeedSelected: selectedFilter.isSuperSpeed,
          color: color,
          onForBoxChange: isBox => onChangeBox(filterId, isBox),
          onInventoryChange: isInventory => onInventoryChange(filterId, isInventory),
          onSuperSpeedChange: isSuperSpeed => {
            onSuperSpeedChange(filterId, isSuperSpeed);
          }
        });
      default:
        return null;
    }
  };
  const handleAllClick = () => {
    onSelectAll(filterId, isAllFilterItemsSelected ? [] : data.map(item => item.id), isAttributes);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, Boolean(filterData.length) && /*#__PURE__*/React.createElement("div", {
    className: cn(className, classes.container),
    "data-filter": filterName,
    "data-is-attributes": isAttributes
  }, /*#__PURE__*/React.createElement(_Accordion, {
    className: classes.expansionPanel,
    expanded: isItemOpened,
    onChange: handlePanelClick
  }, /*#__PURE__*/React.createElement(_AccordionSummary, {
    className: cn(classes.expansionSummary, {
      [classes.expansionPanelOpened]: isItemOpened
    }),
    IconButtonProps: {
      onClick: isItemOpened ? handleMinimizeIconClick : undefined
    },
    expandIcon: isItemOpened ? /*#__PURE__*/React.createElement(MinimizeIcon, {
      className: classes.expandIcon
    }) : /*#__PURE__*/React.createElement(AddIcon, {
      className: classes.expandIcon
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.expansionPanelContent
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.filterName
  }, lowercaseConjunction(filterName)), isShowSelectAll(filterName) && /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: appearAnimationClasses,
    in: isItemOpened && (type === Type.COLOR_CIRCLES || type === Type.CHECKBOX),
    timeout: 500,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: fastAppearAnimationClasses,
    key: isAllFilterItemsSelected ? 'all-selected' : 'not-all-selected',
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", {
    onClick: handleAllClick,
    className: classes.selectAll,
    "data-button": "ToggleSelectAll",
    style: {
      color
    }
  }, isAllFilterItemsSelected ? 'Deselect all' : 'Select all')))))), /*#__PURE__*/React.createElement(_AccordionDetails, {
    className: classes.expansionDetails
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.filterBody
  }, selectTypeOfFilterItem())))));
};